export const formatTime = (date: Date, locale: string[]): string =>
	new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: 'numeric' }).format(date).replace(/ /g, '\xA0');
